import { createAction, props, union } from '@ngrx/store';

export const PaymentDateUpdated = createAction(
  '[Pay On Account Select Payment Method] Payment Date Updated',
  props<{ updatedPaymentDate: Date }>(),
);

const payOnAccountSelectPaymentMethodActions = union({
  paymentDateUpdated: PaymentDateUpdated,
});

export type PayOnAccountSelectPaymentMethodActionsUnion =
  typeof payOnAccountSelectPaymentMethodActions;
